import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  riskDataService,
  assetDataService,
  assetSharedModelService,
  riskSharedModelService,
  praDataService
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-asset-dialog.controller';
import template from './edit-asset-dialog.html';
import assignRiskDialog from '../dialog.assignRiskDialog';
import addTypePresetsDialog from '../dialog.addTypePresetsDialog';
import editRiskDialog from '../../riskAdministration/dialog.editRiskDialog';
import nameValidator, { name as validatorName } from './messages/unique-asset-name.validator.directive';
import prefixValidator, { name as validatorPrefix } from './messages/unique-asset-prefix.validator.directive';
import nameMessagesTpl from './messages/asset.name.messages.html';
import notesMessagesTpl from './messages/asset.notes.messages.html';
import prefixMessagesTpl from './messages/asset.prefix.messages.html';
import assetTagMessagesTpl from './messages/asset.tag.messages.html';
import assetTypeMessagesTpl from './messages/asset.type.messages.html';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';
require('ng-file-upload/dist/ng-file-upload-shim');// Loads itself

export class dialogService {
  getOptions($event, {
    asset,
    assetCriticalities,
    assetDataTypes,
    assetDataUses,
    assetTypes,
    updateCallBack,
    process,
    preselectedAssetTypeId,
    showSyncAsset,
    assetType,
  }) {
    return {
      controller,
      controllerAs: 'editAssetDialogVM',
      locals: {
        asset,
        assetCriticalities,
        assetDataTypes,
        assetDataUses,
        assetTypes,
        updateCallBack,
        process,
        preselectedAssetTypeId,
        showSyncAsset,
        assetType
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.assetAdministration.editAssetDialog', [
  ngFileUpload,
  ssDialogService,
  loaderService,
  assetDataService,
  alerts,
  assignRiskDialog,
  riskDataService,
  assetSharedModelService,
  riskSharedModelService,
  editRiskDialog,
  addTypePresetsDialog,
  praDataService,
])
  .directive(validatorName, nameValidator)
  .directive(validatorPrefix, prefixValidator)
  .service('editAssetDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('asset.name.messages.html', nameMessagesTpl);
    $templateCache.put('asset.notes.messages.html', notesMessagesTpl);
    $templateCache.put('asset.prefix.messages.html', prefixMessagesTpl);
    $templateCache.put('asset.type.messages.html', assetTypeMessagesTpl);
    $templateCache.put('asset.tag.messages.html', assetTagMessagesTpl);
  })
  .name;

console.log('app.components.admin.assetAdministration.editAssetDialog created');
